import { Entity } from "ecsy";
import { getId } from "./entityFactory";
import { Debug } from "./debug";
import { GameElement } from "./gameElementTypes";
import { ElementInfo } from "./components";

let entityTraceRecords = new Map<number, Array<string>>();
let syncTraceRecords = new Map<number, Array<string>>();
let savedEntityDetails = new Map<number, string>();

export function entityTrace(entity: Entity, log: string) {
	if (!Debug.KeepTraceLogs) return;
	const id = entity.id; //intentionally using ecsy id, to track entity ecsy objects not game objects
	if (!savedEntityDetails.has(id)) {
		savedEntityDetails.set(id, `Stored id ${id} ` + getEntityDetails(entity));
	}

	const traceLog = `${log} (Step ${getStepNumber()})`;

	//Save record by ecsy id
	let record = entityTraceRecords.get(id);
	if (!record) {
		record = [];
		entityTraceRecords.set(id, record);
	}
	record.push(traceLog);

	//Save record by sync id
	const syncId = getId(entity)
	if (syncId) {
		record = syncTraceRecords.get(syncId);
		if (!record) {
			record = [];
			syncTraceRecords.set(syncId, record);
		}
		record.push(traceLog);
	}
}

export function getEntityDetails(entity: Entity) {
	const elementInfo = entity.getComponent(ElementInfo);
	const type = elementInfo ? GameElement[elementInfo.type] : "Unknown/Unspecified yet";;
	return `EcsyId: ${entity.id}, SyncId:${getId(entity)}, 
	Components: ${JSON.stringify(Object.keys(entity.getComponents()))} 
	Removed: ${JSON.stringify(Object.keys(entity.getComponentsToRemove()))}
	Type: ${type}`;
}

export function getEntitySummary(entity: Entity) {
	return `Type: ${GameElement[entity.getComponent(ElementInfo).type]} EcsyId: ${entity.id}, SyncId:${getId(entity)},`
}

export function printEntityTrace(entity: Entity) {
	if (!Debug.KeepTraceLogs) return;
	const id = entity.id;
	const record = entityTraceRecords.get(id) || [];
	let entityInfo = savedEntityDetails.get(id);
	if (!entityInfo) {
		entityInfo = entity ? getEntityDetails(entity) : `(Only have id ${id})`;
	}
	const entityLog = record.reduce((prev, curr) => `${prev}\n|-- ${curr}`, `Entity Details: ${entityInfo}\nTimeline:`);
	console.log(entityLog);
	return entityLog;
}

export function printSyncTrace(syncId: number) {
	if (!Debug.KeepTraceLogs) return;
	const record = syncTraceRecords.get(syncId) || [];
	const entityLog = record.reduce((prev, curr) => `${prev}\n|-- ${curr}`, `Sync ID: ${syncId} \nTimeline:`);
	console.log(entityLog);
	return entityLog;
}
